export default __webpack_public_path__ + "static/media/clock.d95d2b88.png";